import { render, staticRenderFns } from "./PrintButton.vue?vue&type=template&id=28b3060b&"
import script from "./PrintButton.vue?vue&type=script&lang=ts&"
export * from "./PrintButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports